import * as React from "react";
import { useTealiumEventProperties, useTrackPageView } from "@grandvisionhq/svc-tealium/events";
import { mapVisualLineItemProductToTealiumProduct, cartToTealiumPriceInfo, cartToTealiumOrderDiscountInfo, getCartSubscriptionFrequency } from "../../../../mappers/analytics/tealium/mappers/analytics/tealium/line-item-to-tealium-product.js";
const TealiumCartPageView = ({
  children,
  cart,
  loading
}) => {
  const { commonEventProperties, getCommonUserProperties } = useTealiumEventProperties();
  const handleCartEvent = React.useCallback(async () => {
    const commonUserProperties = await getCommonUserProperties();
    if (!commonUserProperties) return;
    if (cart && cart?.visualLineItems.length) {
      const lineItems = cart?.visualLineItems;
      const Products = mapVisualLineItemProductToTealiumProduct(lineItems, true);
      const { Order_Subtotal, Order_Total, Order_ProductsAmount } = cartToTealiumPriceInfo(cart);
      const { Order_DiscountCode, Order_DiscountName } = cartToTealiumOrderDiscountInfo(cart);
      return Promise.resolve({
        id: "VirtualPage-View",
        Page_Type: "CartPage",
        Page_Section1: "CartPage",
        ...commonEventProperties,
        ...commonUserProperties,
        Products,
        Order_DiscountCode,
        Order_DiscountName,
        Order_SubscriptionFrequency: getCartSubscriptionFrequency(cart),
        Order_Subtotal,
        Order_Total,
        Order_ProductsAmount
      });
    }
    if (!loading && cart === null) {
      return Promise.resolve({
        id: "VirtualPage-View",
        Page_Type: "CartPage",
        Page_Section1: "CartPage",
        Page_Design: "Empty",
        ...commonEventProperties,
        ...commonUserProperties
      });
    }
    if (!loading && !cart?.lineItems?.length) {
      return Promise.resolve({
        id: "VirtualPage-View",
        Page_Type: "CartPage",
        Page_Section1: "CartPage",
        Page_Design: "Empty",
        ...commonEventProperties,
        ...commonUserProperties
      });
    }
    return;
  }, [cart, commonEventProperties, getCommonUserProperties, loading]);
  useTrackPageView(handleCartEvent);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
};
export {
  TealiumCartPageView
};
//# sourceMappingURL=TealiumCartPageView.js.map
